<template>
  <!-- using autocomplete value "new-password" instead of "off" seems to disable autocomplete better in some browsers. -->
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @search="onSearch"
    :filterable="false"
    @input="(workOrder) => $emit('input', workOrder)"
    autocomplete="new-password"
  >
    <template #option="option">
      <div>
        {{ option.number }} - {{ option.status | humanizedFormat | capitalizeFormat }}
      </div>
      <div class="font-size-sm text-secondary">
        {{ option.description }}
      </div>
    </template>
    <template #no-options="{ search, searching }">
      <template v-if="searching">
        No results found for
        <em>{{ search }}</em>
      </template>
      <em
        style="opacity: 0.7"
        v-else
      >Type to search for work orders</em>
    </template>
  </v-select>
</template>
<script>
import { debounce as _debounce } from 'lodash';

export default {
  name: 'WorkOrdersSelect',
  props: {
    value: Object,
    id: {
      type: String,
      default: 'work-order',
    },
    selectLabel: {
      type: String,
      default: 'number',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    filterParams: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: String,
  },
  data() {
    return {
      options: [],
    };
  },
  methods: {
    onSearch(text, loading) {
      if (text.length) {
        loading(true);
        this.filterWorkOrders(text, loading, this);
      }
    },
    filterWorkOrders: _debounce((text, loading, vm) => {
      const params = {
        ...vm.filterParams,
        text: text,
      };
      vm.$workOrdersAPI.getWorkOrders(params).then((response) => {
        vm.options = response.workOrders;
        loading(false);
      });
    }, 500),
  },
};
</script>
